// extracted by mini-css-extract-plugin
export default {"wrapper":"ThumbnailHeader_wrapper__FJ8SP","image":"ThumbnailHeader_image__ZehNo","spin":"ThumbnailHeader_spin__DXRxk","alpha":"ThumbnailHeader_alpha__p+GFi"};